function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "person-placeholder-rectangular");

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#2d536f",
  width: 320,
  height: 460
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("circle", {
  fill: "#ffffff",
  cx: 161.92,
  cy: 121.03,
  r: 81.03
}), React.createElement("path", {
  fill: "#ffffff",
  d: "M161.92,226.54c-75.69,0-137.68,74.93-142.06,150.62a222.81,222.81,0,0,0,284.12,0C299.61,301.66,237.61,226.54,161.92,226.54Z"
}), React.createElement("path", {
  fill: "#2d536f",
  d: "M161.92,245.7c-66.67,0-121.28,78.83-125.13,158.47,34,33.62,77.56,53.83,125.13,53.83s91.13-20.21,125.14-53.83C283.2,324.73,228.59,245.7,161.92,245.7Z"
}), React.createElement("circle", {
  fill: "#2d536f",
  cx: 161.92,
  cy: 122.54,
  r: 62.85
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 320 460",
    width: 320,
    height: 460
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/person-placeholder-rectangular.39f7000a.svg";
export { SvgComponent as ReactComponent };